<template>
  <header
    :class="{ 'bd-banner-navbar': isBannerEnabled}"
    class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar"
  >
    <div
      class="custom-message"
      v-show="message !== ''"
    >
      <div
        @click="closeMessage"
        class="custom-close"
      ><i class="fa fa-times"></i></div>
      <div class="custom-message-title">{{ messageTitle }}</div>
      <div v-html="message"></div>
    </div>
    <div class="row custom-row">
      <div class="col-sm">
        <a
          @click="toggleNav"
          class="custom-menu"
        ><i class="fa fa-bars"></i></a>
        <!-- asTech Logo -->
        <a
          class="navbar-brand mr-0 mr-md-2 custom-logo-link"
          @click="goHome"
          aria-label="astech"
        >
          <img
            src="~@/assets/images/logo.png"
            alt="astech"
            style="height: 40px"
          />
        </a>
        <span class="custom-wait-time">avg wait time: {{ waitTime }}</span>
      </div>
      <div class="col-sm custom-title">
        <h3>asTech Service Portal</h3>
        <!-- Horizontal Menu Links -->
        <div class="navbar-nav-scroll custom-nav-wrapper">
          <ul class="navbar-nav bd-navbar-nav flex-row custom-nav-links">
            <li
              class="nav-item"
              v-for="n of nav"
              :key="n.name"
            >
              <router-link
                exact
                class="nav-link"
                v-if="isAllowed(n.url)"
                :to="n.url"
                title="n.name"
              >{{n.name}}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm">
        <div class="custom-user">
          <!-- Username / Logout -->
          <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
            <li>
              <div class="custom-interface">
                <span>Interface:</span>
                <select
                  class="ml-2 custom-select"
                  v-model="appSelected"
                  @change="changedInterface"
                >
                  <option
                    v-for="app in apps"
                    :key="app.id"
                    v-bind:value="app.id"
                  >{{app.name}}</option>
                </select>
              </div>
            </li>
            <li
              v-if="userProfile.userName"
              class="nav-item"
            >
              <a
                id="userProfile"
                href="#"
                @click="goUserProfile"
                class="nav-link custom-link"
                title="userProfile"
              >
                <i class="fas fa-user pr-1"></i>
                {{ userProfile.userName }}
              </a>
            </li>
            <li class="nav-item">
              <a
                id="logout"
                href="#"
                @click="logout"
                class="nav-link custom-link"
                title="logout"
              >
                <i class="fas fa-sign-out-alt"></i>
                Logout
              </a>
            </li>
          </ul>
          <!-- <div class="custom-name">
            <span>{{ userProfile.lastName }}</span>
          </div> -->
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import globals from '@/plugins/globals.js'
export default {
  name: 'nav-top',
  data() {
    return {
      nav: [
        // { url: '/dashboard', name: 'Dashboard' },
        // { url: '/servicerequests', name: 'Service Requests' },
        // { url: '/issues', name: 'Issues' }
      ],
      toggleBar: false,
      appSelected: null,
      apps: [
        {
          id: 1,
          name: 'UK/Europe'
        },
        {
          id: 2,
          name: 'Glass US/Canada'
        },
        {
          id: 4,
          name: 'Calibration'
        }
      ],
      messageTitle: '',
      message: '',
      channelData: null,
      lastBeat: null,
      pulse: 45000
    }
  },
  mounted() {
    let $this = this
    this.$eventBus.$on('show-message', this.showMessage)
    this.channel = new BroadcastChannel('service_channel')
    this.channel.onmessage = function (message) {
      if (message !== undefined && message !== null) {
        if (message.data !== undefined && message.data !== null) {
          let json = JSON.parse(message.data)
          $this.channelData = json.value
          if (json.name === 'heartbeat') {
            clearTimeout($this.lastBeat)
            $this.lastBeat = setTimeout(() => {
              if ($this.isHost === false) {
                console.log('HOST take-over')
                $this.setHost(true)
              }
            }, $this.pulse)
            if (json.value !== undefined && json.value !== null) {
              console.log('Updating Monitor Info', json.value)
              $this.updateMonitorInfo(json.value)
            }
          } else if (json.name === 'interface') {
            globals.setApp(json.value)
            $this.$eventBus.$emit('hub-getConnectedAstechs', true)
            $this.$eventBus.$emit('refresh-chat')
            $this.appSelected = json.value
          }
        }
      }
    }
    this.appSelected = globals.getApp()
  },
  computed: {
    ...mapGetters('auth', ['userProfile', 'isAllowed']),
    ...mapGetters('astechhub', ['isHost']),
    ...mapGetters('serviceRequests', ['requestCount']),
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    fullname() {
      let name = ''
      if (this.userProfile !== undefined && this.userProfile !== null) {
        name = `${this.userProfile.firstName} ${this.userProfile.lastName}`.trim()
      }
      return name
    },
    waitTime() {
      let _time = '< 1 min'
      if (this.requestCount !== undefined && this.requestCount !== null) {
        _time = `${parseInt(this.requestCount.avgWaitTime / 60)} min`
      }
      return _time
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    ...mapActions('astechhub', ['setHost', 'updateMonitorInfo']),
    logout() {
      this.clearToken()
      this.toggleBar = false
      this.$emit('toggleBar', this.toggleBar)
      window.location.assign('/')
    },
    toggleNav() {
      this.toggleBar = !this.toggleBar
      this.$emit('toggleBar', this.toggleBar)
    },
    closeMenu() {
      this.toggleBar = false
      this.$emit('toggleBar', this.toggleBar)
    },
    goHome() {
      this.toggleBar = false
      this.$emit('toggleBar', this.toggleBar)
      window.location.assign('/')
    },
    goUserProfile() {
      this.toggleBar = false
      this.$emit('toggleBar', this.toggleBar)
      window.location.assign('/user')
    },
    showMessage(msg) {
      let $this = this
      this.messageTitle = msg.title
      this.message = msg.message
      if (msg.timeout !== undefined && msg.timeout !== null) {
        if (msg.timeout > 0) {
          setTimeout(() => {
            $this.message = ''
          }, msg.timeout)
        }
      }
    },
    closeMessage() {
      this.message = ''
    },
    changedInterface() {
      const bc = new BroadcastChannel('service_channel')
      let sync = {
        name: 'interface',
        value: this.appSelected
      }
      bc.postMessage(JSON.stringify(sync))
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('show-message')
  }
}
</script>
<style lang="scss" scoped>
.custom-wait-time {
  font-weight: 600;
}
.custom-logo-link {
  cursor: pointer;
}
.custom-row {
  width: 100%;
}
.custom-nav-links {
  li {
    font-weight: 500;
    font-size: 18px;
  }
}
.custom-menu {
  margin-right: 15px;
  font-size: 1.5em;
  font-weight: 600;
  cursor: pointer;
  :hover {
    color: blue;
  }
}
.custom-title {
  text-align: center;
  width: 100%;
  margin: 0 auto;
}
.custom-link {
  cursor: pointer;
}
.custom-user {
  float: right;
}
.custom-name {
  text-align: center;
  font-size: 0.8em;
  margin: 0 auto;
  padding: 0;
  width: 100%;
}
.custom-interface {
  top: 2px;
  display: inline-flex;
  position: relative;
  span {
    margin-top: 5px;
  }
  margin-right: 10px;
}
.custom-message {
  position: absolute;
  z-index: 10;
  width: 500px;
  top: 1px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: 90px;
  max-height: 90px;
  padding: 3px;
  background-color: rgb(255, 255, 149);
  border: 1px solid rgb(173, 173, 173);
  border-radius: 5px;
  box-shadow: 3px 5px 3px #cecece;
  overflow-x: hidden;
  overflow-y: auto;
  .custom-message-title {
    font-size: 1em;
    font-weight: 500;
    width: 100%;
  }
  .custom-close {
    float: right;
    width: 20px;
    height: 20px;
    color: rgb(0, 0, 255);
    text-align: center;
    vertical-align: middle;
    :hover {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/nav-top.vue